var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembers = function SvgMembers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_32443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1036 48.002C72.5716 48.002 78.6256 41.948 78.6256 34.48C78.6256 27.012 72.5716 20.958 65.1036 20.958C57.6356 20.958 51.5815 27.012 51.5815 34.48C51.5815 41.948 57.6356 48.002 65.1036 48.002Z",
    fill: "url(#paint0_linear_164_32443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.104 50.9873C51.555 50.9873 40.521 60.0741 40.521 71.2703C40.521 72.0276 41.116 72.6225 41.8732 72.6225H88.3348C89.0921 72.6225 89.687 72.0276 89.687 71.2703C89.687 60.0741 78.6531 50.9873 65.104 50.9873Z",
    fill: "url(#paint1_linear_164_32443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1984 54.9183C50.6536 54.9183 59.1292 46.4427 59.1292 35.9875C59.1292 25.5323 50.6536 17.0566 40.1984 17.0566C29.7432 17.0566 21.2676 25.5323 21.2676 35.9875C21.2676 46.4427 29.7432 54.9183 40.1984 54.9183Z",
    fill: "url(#paint2_linear_164_32443)",
    stroke: "white",
    strokeWidth: 4.5283
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1984 54.0693C22.6761 54.0693 7.63429 65.8941 7.63429 81.3335C7.63429 83.5173 9.38132 85.2643 11.5651 85.2643H68.8318C71.0156 85.2643 72.7626 83.5173 72.7626 81.3335C72.7626 65.8941 57.7208 54.0693 40.1984 54.0693Z",
    fill: "url(#paint3_linear_164_32443)",
    stroke: "white",
    strokeWidth: 4.5283
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_32443",
    x1: 65.2792,
    y1: 20.958,
    x2: 62.4599,
    y2: 49.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_32443",
    x1: 65.4233,
    y1: 50.9873,
    x2: 64.4231,
    y2: 74.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_164_32443",
    x1: 40.0802,
    y1: 23.808,
    x2: 41.0321,
    y2: 52.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_164_32443",
    x1: 39.9835,
    y1: 59.9232,
    x2: 40.3189,
    y2: 82.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_32443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "members.9df1428d07739acdf7424f8ecc87336d.svg";